import React from 'react'
import { Card } from '@paintscout/ui'
import StatCard5minBackground from './svgs/StatCard5minBackground'
import StatCard350kBackground from './svgs/StatCard350kBackground'
import StatCard1JobBackground from './svgs/StatCard1JobBackground'
import StatCard2BBackground from './svgs/StatCard2BBackground'

/**
 * The four marketing stat cards — 5min, 350k+, 1 Job, 2B+.
 *
 * Shared by the trial-expired dashboard and the deactivated block screen (ENG-1532), on both
 * desktop and mobile. The four SVGs carry their own text, so there is nothing to translate or
 * configure here; the only thing that varies between the four call sites is the grid CSS, which
 * is why the classes come in as a prop rather than being owned here.
 *
 * Deliberately not used by SherwinTrialOverDashboard: that screen shows a coupon card in this
 * slot instead, and keeps its own layout stylesheet.
 */
export interface StatCardsProps {
  classes: {
    statsGrid: string
    statCard: string
    statCardBackground: string
  }
}

export default function StatCards({ classes }: StatCardsProps) {
  const backgrounds = [
    <StatCard5minBackground key="5min" />,
    <StatCard350kBackground key="350k" />,
    <StatCard1JobBackground key="1job" />,
    <StatCard2BBackground key="2b" />
  ]

  return (
    <div className={classes.statsGrid}>
      {backgrounds.map((background, index) => (
        <Card key={index} className={classes.statCard}>
          <div className={classes.statCardBackground}>{background}</div>
        </Card>
      ))}
    </div>
  )
}
